import {match, Pattern} from 'ts-pattern';

import {Nullish} from 'shared/web';

/**
 * The `status=ACTIVE` count includes drafts, and the create flow creates its own draft
 * before the second section renders — so the case being created counts itself.
 */
export function getOtherActiveServiceCasesCount(
  activeServiceCasesCount: number | Nullish,
  hasOwnDraft: boolean
) {
  return match({activeServiceCasesCount, hasOwnDraft})
    .with({activeServiceCasesCount: Pattern.nullish}, () => 0)
    .with(
      {activeServiceCasesCount: Pattern.number, hasOwnDraft: true},
      ({activeServiceCasesCount}) => Math.max(activeServiceCasesCount - 1, 0)
    )
    .otherwise(({activeServiceCasesCount}) => activeServiceCasesCount ?? 0);
}
